import {
  numOrletter,
  vrifyCode,
  vrifyCode2,
  agentCode,
  checkQQ,
  checkWechat,
  realName,
  email,
  checkDrawPwd,
  Required,
  bank,
  phone,
  checkTelegram,
  checkWhatsapp,
} from "@/common/utils/validate.js";
import store from "@/common/store/";
import i18n from "../i18n/i18n";
let database = (that) => {
  return that.$store.state.langs.database[that.$store.state.langs.keys];
};

export const requiredBlur = (that) => {
  return [
    {
      required: true,
      message: database(that).Forms.requiredFields,
      trigger: "blur",
    },
  ];
};

// 验证两个参数是否合法是否一致
// that 调用页面this, objName 对比参数对象, keyName1 对比参数1, keyName2 对比参数2,
// ruleYz 验证合法规则 errormsg 对象 错误提示信息
export function checkDisparity({
  that,
  objName,
  keyName1,
  keyName2,
  ruleYz,
  errormsg,
}) {
  var check = ruleYz || numOrletter;
  var defaultError = {
    // 默认提示信息
    required1: database(that).Forms.newPwdPlace,
    err1: database(that).register.passwordPlace,
    required2: database(that).Forms.repeatPwdPlace,
    err2: database(that).Forms.newDiff,
  };
  var error = errormsg || { ...defaultError };
  var validate1 = (rule, value, callback) => {
    if (value === "") {
      callback(new Error(error.required1));
    } else {
      if (!check.test(value)) {
        callback(new Error(error.err1));
      } else {
        if (that[objName][keyName2] !== "") {
          that.$refs[objName].validateField(keyName2);
        }
      }
      callback();
    }
  };
  var validate2 = (rule, value, callback) => {
    if (value === "") {
      callback(new Error(error.required2));
    } else {
      if (that[objName][keyName1] !== "" && value !== that[objName][keyName1]) {
        callback(new Error(error.err2));
      } else {
        callback();
      }
    }
  };
  return { validate1, validate2 };
}

// 登录
export const loginRF = {
  username: "",
  password: "",
  vrifyCode: "",
  timestamp: "",
};
export const loginR = (that) => {
  return {
    username: [
      ...requiredBlur(that),
      // { pattern: numOrletter, message: database(that).register.usernamePlace, trigger: 'blur' }
    ],
    password: [
      ...requiredBlur(that),
      // { pattern: numOrletter, message: database(that).register.passwordPlace, trigger: 'blur' }
    ],
    vrifyCode: [
      ...requiredBlur(that),
      {
        pattern: vrifyCode,
        message: database(that).register.vrifyCodePlace,
        trigger: "blur",
      },
    ],
    timestamp: [],
  };
};

// 注册
export const registerRF = {
  username: "",
  password: "",
  repeatPassword: "",
  phone: "",
  agentCode: "",
  regDomain: "",
  timestamp: "",
  vrifyCode: "",
  realName: "",
  qq: "",
  wechat: "",
  telegram: "",
  whatsapp: "",
  email: "",
  withdrawPassword: "",
  registerType: "", //是否为新注册页  0旧 1新  可不传
};

export const registerR = (that) => {
  return {
    username: [
      ...requiredBlur(that),
      {
        pattern: numOrletter,
        message: i18n.t("register.usernamePlace"),
        trigger: "blur",
      },
    ],
    password: [
      ...requiredBlur(that),
      // { validator: checkPwd('ruleForm', 'password', 'repeatPassword').validate1, trigger: 'blur' }
      {
        pattern: numOrletter,
        message: database(that).register.passwordPlace,
        trigger: "blur",
      },
    ],
    repeatPassword: [
      ...requiredBlur(that),
      // { validator: checkPwd('ruleForm', 'password', 'repeatPassword').validate2, trigger: 'blur' }
      {
        pattern: numOrletter,
        message: database(that).register.passwordPlace,
        trigger: "blur",
      }, // repeatPasswordPlace
    ],
    phone: [
      ...requiredBlur(that),
      {
        pattern: phone,
        message: database(that).register.phoneTips,
        trigger: "blur",
      },
    ],
    agentCode: [
      ...requiredBlur(that),
      {
        pattern: agentCode,
        message: database(that).register.agentCodePlace,
        trigger: "blur",
      },
    ],
    vrifyCode: [
      ...requiredBlur(that),
      {
        pattern: vrifyCode2,
        message: database(that).register.vrifyCodePlace,
        trigger: "blur",
      },
    ],
    realName: [
      ...requiredBlur(that),
      {
        pattern: realName,
        message: database(that).register.realNameTips,
        trigger: "blur",
      },
    ],
    qq: [
      ...requiredBlur(that),
      {
        pattern: checkQQ,
        message: database(that).register.qqError,
        trigger: "blur",
      },
    ],
    wechat: [
      ...requiredBlur(that),
      {
        pattern: checkWechat,
        message: database(that).register.wechatError,
        trigger: "blur",
      },
    ],
    telegram: [
      ...requiredBlur(that),
      {
        pattern: checkTelegram,
        message: database(that).register.telegramError,
        trigger: "blur",
      },
    ],
    whatsapp: [
      ...requiredBlur(that),
      {
        pattern: checkWhatsapp,
        message: database(that).register.whatsappError,
        trigger: "blur",
      },
    ],
    email: [
      ...requiredBlur(that),
      {
        pattern: email,
        message: database(that).register.emailPlace,
        trigger: "blur",
      },
    ],
    withdrawPassword: [
      ...requiredBlur(that),
      {
        pattern: checkDrawPwd,
        message: database(that).Forms.drawPwdError,
        trigger: "blur",
      },
    ],
  };
};

// 实名表单验证
export const VerifiedAuthRules = (that) => {
  return {
    userName: [
      {
        required: true,
        message: database(that).mine.verifiedAuth.namePlace,
        trigger: "blur",
      },
      {
        pattern: Required,
        message: database(that).mine.verifiedAuth.namePlace,
        trigger: "blur",
      },
    ],
    idNumber: [
      {
        required: true,
        message: database(that).mine.verifiedAuth.IDNOPlace,
        trigger: "blur",
      },
      {
        pattern: Required,
        message: database(that).mine.verifiedAuth.IDNOPlace,
        trigger: "blur",
      },
    ],
  };
};

// 手机号认证
export const phoneAuthRules = (that) => {
  return {
    phone: [
      {
        required: true,
        message: database(that).mine.mobileAuth.phonePlace,
        trigger: "blur",
      },
      {
        pattern: phone,
        message: database(that).mine.mobileAuth.phonePlace,
        trigger: "blur",
      },
    ],
    phoneYzm: [
      {
        required: true,
        message: database(that).mine.mobileAuth.verifCodePlace,
        trigger: "blur",
      },
      {
        pattern: Required,
        message: database(that).mine.mobileAuth.verifCodePlace,
        trigger: "blur",
      },
    ],
  };
};

// 邮箱认证
export const emailAuthRules = (that) => {
  return {
    email: [
      {
        required: true,
        message: database(that).mine.emailAuth.emailPlace,
        trigger: "blur",
      },
      {
        pattern: email,
        message: database(that).mine.emailAuth.emailError,
        trigger: "blur",
      },
    ],
    confirmCode: [
      {
        required: true,
        message: database(that).mine.emailAuth.verifCodePlace,
        trigger: "blur",
      },
      {
        pattern: Required,
        message: database(that).mine.emailAuth.verifCodePlace,
        trigger: "blur",
      },
    ],
  };
};

// 添加银行卡验证
export const addBankRules = (that) => {
  return {
    personName: [
      {
        required: true,
        message: database(that).mine.Withdrawal.addbankcard.personNamePlace,
        trigger: "blur",
      },
      {
        pattern: Required,
        message: database(that).mine.Withdrawal.addbankcard.personNamePlace,
        trigger: "blur",
      },
    ],
    bankName: [
      {
        required: true,
        message: database(that).mine.Withdrawal.addbankcard.bankNamePlace,
        trigger: "blur",
      },
      {
        pattern: Required,
        message: database(that).mine.Withdrawal.addbankcard.bankNamePlace,
        trigger: "blur",
      },
    ],
    cardNumber: [
      {
        required: true,
        message: database(that).mine.Withdrawal.addbankcard.cardNumberPlace,
        trigger: "blur",
      },
      {
        pattern: bank,
        message: database(that).mine.Withdrawal.addbankcard.cardNumberError,
        trigger: "blur",
      },
    ],
    subBank: [
      {
        required: true,
        message: database(that).mine.Withdrawal.addbankcard.bankBranchPlace,
        trigger: "blur",
      },
      {
        pattern: Required,
        message: database(that).mine.Withdrawal.addbankcard.bankBranchPlace,
        trigger: "blur",
      },
    ],
    bankBindPhone: [
      {
        required: true,
        message: database(that).mine.Withdrawal.addbankcard.bankBindPhonePlace,
        trigger: "blur",
      },
      {
        pattern: phone,
        message: database(that).mine.Withdrawal.addbankcard.bankBindPhonePlace,
        trigger: "blur",
      },
    ],
    withdrawPassword: [
      {
        required: true,
        message:
          database(that).mine.Withdrawal.addbankcard.withdrawPasswordPlace,
        trigger: "blur",
      },
      {
        pattern: checkDrawPwd,
        message: database(that).Forms.drawPwdError,
        trigger: "blur",
      },
    ],
  };
};

// 发送站内信
export const sendMsgRules = (that) => {
  return {
    msgType: [
      {
        required: true,
        message: database(that).mine.stationLetter.selectMsgType,
        trigger: "blur",
      },
      {
        pattern: Required,
        message: database(that).mine.stationLetter.selectMsgType,
        trigger: "blur",
      },
    ],
    title: [
      {
        required: true,
        message: database(that).mine.stationLetter.themePlace,
        trigger: "blur",
      },
      {
        pattern: Required,
        message: database(that).mine.stationLetter.themePlace,
        trigger: "blur",
      },
    ],
    content: [
      {
        required: true,
        message: database(that).mine.stationLetter.descPlace,
        trigger: "blur",
      },
      {
        pattern: Required,
        message: database(that).mine.stationLetter.descPlace,
        trigger: "blur",
      },
    ],
  };
};

// 忘记密码
export const forgetRules = (that) => {
  return {
    username: [
      ...requiredBlur(that),
      {
        pattern: numOrletter,
        message: database(that).Forms.nameCheck,
        trigger: "blur",
      },
    ],
    phone: [
      ...requiredBlur(that),
      {
        pattern: phone,
        message: database(that).Forms.phoneCheck,
        trigger: "blur",
      },
    ],
    email: [
      ...requiredBlur(that),
      {
        pattern: email,
        message: database(that).Forms.emailCheck,
        trigger: "blur",
      },
    ],
  };
};



// WEBPACK FOOTER //
// ./src/pages/build800/libs/rule-form.js